import { Injectable } from "@angular/core";
import { CoreLogService } from "../../services/log.service";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { ServiceCallDataModel } from "../../shared/models";
import { IObjectObserver } from "../../services/IObjectObserver";
import { ContentType } from "../../shared/contentTypes";
import { ObjectObserverFactory } from "../../services/objectObserverFactory";
import { Observable } from "rxjs";

@Injectable()
export class ServiceCallService {

  private _servciecallObsServer: IObjectObserver<ServiceCallDataModel>;

  constructor(private _coreLogService: CoreLogService,
    objObsInjectHelper: CircularInjectionHelper) {
    const me = this;
    me._servciecallObsServer = ObjectObserverFactory.GetObjectObserverByInjectionHelper<ServiceCallDataModel>(ContentType.Inhouse_ServiceCalls, objObsInjectHelper);
  }

  public get ObserveServiceCallsChanges(): Observable<(string | number)[]> {
    return this._servciecallObsServer.ObserveChanges;
  }

  public GetServiceCalls(): Promise<ServiceCallDataModel[]> {
    const me = this;
    return new Promise<ServiceCallDataModel[]>((resolve, reject) => {
      me._servciecallObsServer.GetObjectsByFilter(model => model.enabled && !model.deleted)
        .then((service_calls) => {
          service_calls.sort((l, r) => {
            if (l.sort_number < r.sort_number) {
              return -1;
            } else if (l.sort_number = r.sort_number) {
              return 1;
            } else {
              return 0;
            }
          });
          resolve(service_calls);
        }).catch((error) => {
          me._coreLogService.error("InHauseServiceSelectorService.GetServiceCalls", "GetObjectsByFilter", error);
          reject();
        });
    });
  }
}
